import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom'; // Import useNavigate
import './ProductsDetails.css'; // Import the new CSS file

function ProductDetails({ addToCart }) {
  const { id } = useParams(); // Get product ID from URL
  const navigate = useNavigate(); // Hook for navigation

  const products = {
    1: {
      name: '蛋黃酥',
      price: 14,
      originalPrice: 14,
      image: '/Homepage/eggyolk_pastry.jpg',
      explanationImage: '/product_details/eggyolk_pastry_details.png',
    },
    2: {
      name: '芋泥蛋黃酥',
      price: 14,
      originalPrice: 14,
      image: '/Homepage/taropastry.jpg',
      explanationImage: '/Homepage/taropastry_details.jpg',
    },
    3: {
      name: '鳳梨酥',
      price: 12.5,
      originalPrice: 12.5,
      image: '/Homepage/pineapplecake.jpg',
      explanationImage: '/Homepage/pineapplecake_details.jpg',
    },
    4: { name: '胡椒餅', price: 12, originalPrice: 14, image: '/Homepage/pepper_cake.jpg' },
    5: { name: '綠豆椪 (肉鬆)', price: 14, originalPrice: 16, image: '/Homepage/greenbean.jpg' },
    6: { name: '太陽餅', price: 12, originalPrice: 13, image: '/Homepage/suncake.jpg' },
  };

  const product = products[id];
  const [quantity, setQuantity] = useState(1);

  const increaseQuantity = () => setQuantity((prev) => prev + 1);
  const decreaseQuantity = () => setQuantity((prev) => (prev > 1 ? prev - 1 : 1));

  const handleBuyNow = () => {
    navigate('/cart', {
      state: { product: { ...product, quantity } }, // Pass product and quantity to cart
    });
  };

  return product ? (
    <div className="product-container">
      {/* Product Detail Section */}
      <div className="product-details">
        {/* Left Section */}
        <div className="image-section">
          {/* Small Image Gallery */}
          <div className="image-gallery">
            <img src={product.image} alt={product.name} />
            <img src={product.image} alt={product.name} />
            <img src={product.image} alt={product.name} />
          </div>
          {/* Big Image */}
          <div className="big-image">
            <img src={product.image} alt={product.name} />
          </div>
        </div>
  
        {/* Right Product Details */}
        <div className="product-info">
          <h1>{product.name}</h1>
          <p><span className="product-explanation">袋裝 4入</span></p>
          <p>
            <span className="product-price">${product.price.toFixed(2)}</span>
            <span className="product-original-price">${product.originalPrice.toFixed(2)}</span>
          </p>
  
          {/* Quantity Selector */}
          <div className="quantity-selector">
            <button onClick={decreaseQuantity}>-</button>
            <input type="text" value={quantity} readOnly />
            <button onClick={increaseQuantity}>+</button>
          </div>
  
          {/* Action Buttons */}
          <div className="action-buttons">
            <button
              className="add-to-cart-btn"
              onClick={() => addToCart({ ...product, quantity })}
            >
              加入購物車
            </button>
            <button className="buy-now-btn" onClick={handleBuyNow}>
              立即購買
            </button>
          </div>
        </div>
      </div>
  
      {/* Explanation Section */}
      <div className="product-explanation-section">
        {/* Top Line */}
        <div className="line"></div>
        <h2 className="section-title">商品描述</h2>
        {/* Explanation Image */}
        <div className="explanation-image">
          <img src={product.explanationImage} alt={`${product.name} 說明`} />
        </div>
  
        {/* Bottom Line */}
        <div className="line"></div>
      </div>
    </div>
  ) : (
    <p>產品不存在</p>
  );
}

export default ProductDetails;